import { z } from 'zod';
export const userMessageZSchema = z.object({
    action: z.string().nullish(),
    content: z.string(),
    id: z.number(),
    title: z.string(),
    actionText: z.string(),
    createdOn: z.string(),
});
